import { Select, TextField, TrashButton, Switch } from "components/Core"
import { TYPE_DINAMIC } from "components/FormEntities/FormSource/source.config"
import { useEffect, useState } from "react"
import { Controller } from "react-hook-form"
import cn from "classnames"

interface ILocationFields {
  index: number
  control: any
  watch: any
  location: any
  errors: any
}

const LocationFields = ({ index, control, watch, location, errors }: ILocationFields) => {
  const [is_array, set_is_array] = useState(false)
  const _key = watch(`location[${index}].key`)
  const type = watch(`location[${index}].type`)
  const remove_location = () => location.remove(index)

  useEffect(() => {
    if (type === "array-string") {
      set_is_array(true)
    } else {
      set_is_array(false)
    }
  }, [type])

  return (
    <div className="w-full flex flex-col gap-4">
      <div className="w-full flex flex-row items-center justify-between p-2">
        <h4 className="">Ubicación {Number(index + 1)}</h4>
        <TrashButton onClick={remove_location} />
      </div>
      <div className="w-full border-b border-[#919191]"></div>
      <Controller
        control={control}
        name={`location[${index}].key`}
        defaultValue={location.fields[index].key}
        render={({ field: { onChange, value } }) => (
          <TextField
            label="Clave"
            onChange={onChange}
            value={value}
            helperText={
              _key.includes("coordinates") ? "El valor debe incluir las coordenadas, en formato 'latitud+longitud'" : ""
            }
          />
        )}
      />
      <div
        className={cn("flex flex-row gap-4", {
          "mt-2": _key.includes("coordinates"),
        })}
      >
        <Controller
          name={`location[${index}].type`}
          defaultValue={location.fields[index].type}
          control={control}
          render={({ field: { onChange, value } }) => (
            <Select label="Tipo" options={TYPE_DINAMIC} onChange={onChange} value={value} />
          )}
        />
        {type === "boolean" ? (
          <Controller
            name={`location[${index}].value`}
            control={control}
            defaultValue=""
            render={({ field: { onChange, value } }) => <Switch label="Valor" onChange={onChange} checked={value} />}
          />
        ) : (
          <Controller
            control={control}
            name={`location[${index}].value`}
            defaultValue={location.fields[index].value}
            render={({ field: { onChange, value } }) => (
              <TextField
                label="Valor"
                onChange={onChange}
                value={value}
                helperText={is_array ? "Para concatenar correctamente, ingresa cada valor seguido del '+'." : ""}
              />
            )}
          />
        )}
      </div>
    </div>
  )
}

export default LocationFields
